import {IErrorChannels, ISop} from "@shared/sop/models";
import {IACsvValue} from "@toolbox/display-blocks/models";
import {EDeviceClasses, IDeviceId} from "@toolbox/models";
import {IAdvancedDevice} from "./wizard/models";

export enum ENormalizationType {
    EmptyChannel,
    EmptyCuvette,
}

export enum ENormalizationWarnings {
    None,
    Date,
    Temperature,
}

export interface IDuration {
    total: number;
    cycles: ICycleDuration[];
}

export interface ICycleDuration {
    duration: number;
    startTime: number;
    endTime: number;

    min: number;
    limitedSchedule: boolean;
}

export interface ICellTypeModel {
    id: number;
    name: string;

    compatibleDevices: EDeviceClasses[];

    layerDepth: number;
    mass: number;
}

export interface IChannelModel extends IErrorChannels {
    cellType: number | string;
    normalizationType: ENormalizationType;
}

export interface ICycleModel {
    interval: number;
    profiles: number;
    lightFactor: number;

    level: number;
    temperature: number;
}

export interface ISopModel {
    name: string;
    device: IAdvancedDevice | IDeviceId;
    notes: string;

    cycles: ICycleModel[];
    channels: IChannelModel[];
    forceNewNormalizations: boolean;
    wavelengths: number[];

    acsv?: IACsvValue;
}

export interface ISopStorage extends ISopModel, ISop {
    filtrationModule: boolean;
    isNameDefinitionRequired: boolean;

    tags: string[];
    templates: number[];
}

export interface ICentSopModel extends ISopStorage {
    creator: string;
    owner: string;
}
